import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IPalishReceipt,
  IPalishReceiptInitialState,
} from "./palishReceiptModel";
import {
  createPalishReceipt,
  deletePalishReceipt,
  deletePalishReceiptOrderItems,
  findAllPalishReceipt,
  findAllPendingPalishOrder,
  getPalishReceiptById,
  updatePalishReceipt,
} from "./services/palishReceipt.services";

const initialState: IPalishReceiptInitialState = {
  loading: false,
  error: "",
  PalishReceiptID: null,
  PalishReceiptOrderItemIndex: -1,
  PalishReceiptOrderSelectionDialog: false,
  PalishReceiptList: [],
  PalishPendingOrderList: [],
  PalishReceiptDetail: {
    karigar_id: null,
    receipt_date: new Date(),
    receipt_no: null,
    karigar_name: "",
    charges: null,
    gold_rate: null,
    palish_receipt_order: [],
  },
  FilterPalishReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
};

const palishReceiptSlice = createSlice({
  name: "palishreceipt",
  initialState,
  reducers: {
    setPalishReceiptID: (state, action) => {
      state.PalishReceiptID = action.payload;
    },
    clearPalishReceiptDetail: (state) => {
      state.PalishReceiptDetail = initialState.PalishReceiptDetail;
    },
    setPalishReceiptOrderItemIndex: (state, action) => {
      state.PalishReceiptOrderItemIndex = action.payload;
    },
    setFilterPalishReceipt: (state, action) => {
      state.FilterPalishReceipt = action.payload;
    },
    clearFilterPalishReceipt: (state) => {
      state.FilterPalishReceipt = initialState.FilterPalishReceipt;
    },
    openPalishReceiptOrderSelectionDialog: (state) => {
      state.PalishReceiptOrderSelectionDialog = true;
    },
    closePalishReceiptOrderSelectionDialog: (state) => {
      state.PalishReceiptOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllPalishReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllPalishReceipt.fulfilled,
      (state, action: PayloadAction<IPalishReceipt[]>) => {
        state.loading = false;
        state.PalishReceiptList = action.payload || [];
      }
    );
    builder.addCase(findAllPalishReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PalishReceiptList = [];
    });

    builder.addCase(createPalishReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createPalishReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPalishReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updatePalishReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePalishReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePalishReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deletePalishReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePalishReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePalishReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getPalishReceiptById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPalishReceiptById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PalishReceiptDetail = action.payload;
    });
    builder.addCase(getPalishReceiptById.rejected, (state, action) => {
      state.loading = false;
      state.PalishReceiptDetail = initialState.PalishReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deletePalishReceiptOrderItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePalishReceiptOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePalishReceiptOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(findAllPendingPalishOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllPendingPalishOrder.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.PalishPendingOrderList = action.payload || [];
      }
    );
    builder.addCase(findAllPendingPalishOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PalishPendingOrderList = [];
    });
  },
});

export const {
  clearPalishReceiptDetail,
  setPalishReceiptID,
  setPalishReceiptOrderItemIndex,
  clearFilterPalishReceipt,
  setFilterPalishReceipt,
  closePalishReceiptOrderSelectionDialog,
  openPalishReceiptOrderSelectionDialog,
} = palishReceiptSlice.actions;
export default palishReceiptSlice.reducer;
